import { createSlice } from "@reduxjs/toolkit";

import { TaskRunnerInterface } from "./taskRunner";

const initialState: TaskRunnerInterface = {
  runningTaskStartTime: '00:00:00',
};

export const taskRunnerSlice = createSlice({
  name: "taskRunner",
  initialState,
  reducers: {
    updateOffsetTime: (state, action: { payload: TaskRunnerInterface }) => {
      state.runningTaskStartTime = action.payload.runningTaskStartTime;
    },
  },
});

export const { updateOffsetTime } = taskRunnerSlice.actions;
